export const ClientFormData = (client = null) => {
  return {
    Address: client?.Address ? client.Address : "",
    Address2: client?.Address2 ? client.Address2 : "",
    BankAccountNumberIBAN: client?.BankAccountNumberIBAN
      ? client.BankAccountNumberIBAN
      : "",
    Email: client?.Email ? client.Email : "",
    BankBICCode: client?.BankBICCode ? client.BankBICCode : "",
    BankGiroNumber: client?.BankGiroNumber ? client.BankGiroNumber : "",
    PlusGiroNumber: client?.PlusGiroNumber ? client.PlusGiroNumber : "",
    VATRegistration: client?.VATRegistration ? client.VATRegistration : "",
    CNr: client?.CNr ? client.CNr : "",
    CaseHandler: client?.CaseHandler ? client.CaseHandler : "",
    City: client?.City ? client.City : "",
    Id: client?.Id ? client.Id : "",
    ContactPerson: client?.ContactPerson ? client.ContactPerson : "",
    ContactPerson2: client?.ContactPerson2 ? client.ContactPerson2 : "",
    ContactPersonMobileNumber: client?.ContactPersonMobileNumber
      ? client.ContactPersonMobileNumber
      : "",
    ContactPerson2MobileNumber: client?.ContactPerson2MobileNumber
      ? client.ContactPerson2MobileNumber
      : "",
    ContactPersonRole: client?.ContactPersonRole
      ? client.ContactPersonRole
      : "",
    ContactPerson2Role: client?.ContactPerson2Role
      ? client.ContactPerson2Role
      : "",
    ContactPersonEmail: client?.ContactPersonEmail
      ? client.ContactPersonEmail
      : "",
    ContactPerson2Email: client?.ContactPerson2Email
      ? client.ContactPerson2Email
      : "",
    CountryCode: client?.CountryCode ? client.CountryCode : "",
    CreateTime: client?.CreateTime ? client.CreateTime : "",
    DefaultAgreement: client?.DefaultAgreement ? client.DefaultAgreement : "",
    DefaultService: client?.DefaultService ? client.DefaultService : "",
    FfdLevel1: client?.FfdLevel1 ? client.FfdLevel1 : 30,
    Ffd1CreditFee: client?.Ffd1CreditFee ? client.Ffd1CreditFee : 0,
    FfdLevel2: client?.FfdLevel2 ? client.FfdLevel2 : 45,
    Ffd2CreditFee: client?.Ffd2CreditFee ? client.Ffd2CreditFee : 0,
    FfdLevel3: client?.FfdLevel3 ? client.FfdLevel3 : 60,
    Ffd3CreditFee: client?.Ffd3CreditFee ? client.Ffd3CreditFee : 0,
    LanguageCode: client?.LanguageCode != null ? client.LanguageCode : "",
    LatePaymentInterestPercentage: client?.LatePaymentInterestPercentage
      ? client.LatePaymentInterestPercentage
      : "",
    MaxCredit: client?.MaxCredit ? client.MaxCredit : "",
    Name: client?.Name ? client.Name : "",
    Name2: client?.Name2 ? client.Name2 : "",
    OrgNo: client?.OrgNo ? client.OrgNo : "",
    OriginalFfd: client?.OriginalFfd ? client.OriginalFfd : "30",
    CollectionWaitCreate: client?.CollectionWaitCreate
      ? client.CollectionWaitCreate
      : "",
    PostalCode: client?.PostalCode ? client.PostalCode : "",
    PurchaseDirectPaymentPercentage: client?.PurchaseDirectPaymentPercentage
      ? client.PurchaseDirectPaymentPercentage
      : "",
    Regress: client?.Regress ? client.Regress : "",
    ParseStatus: client?.ParseStatus ? client.ParseStatus : "",
    ParseMessage: client?.ParseMessage ? client.ParseMessage : "",
    SystemStatus: client?.SystemStatus ? client.SystemStatus : "",
    ServiceFeePurchase: client?.ServiceFeePurchase
      ? client.ServiceFeePurchase
      : "",
    ServiceFeeService: client?.ServiceFeeService
      ? client.ServiceFeeService
      : "",
    ServiceFeeCredit: client?.ServiceFeeCredit ? client.ServiceFeeCredit : "",
    ServiceFeeRegress: client?.ServiceFeeRegress
      ? client.ServiceFeeRegress
      : "",
    TelephoneNumber: client?.TelephoneNumber ? client.TelephoneNumber : "",
    Template: client?.Template != null ? client.Template : 0,
    Website: client?.Website ? client.Website : "",
    // UC: mockedUCValues,
    UC_OrganisationNumber: client?.UC_OrganisationNumber
      ? client.UC_OrganisationNumber
      : "",
    UC_NumberOfComplaints: client?.UC_NumberOfComplaints
      ? client.UC_NumberOfComplaints
      : "",
    UC_Status: client?.UC_Status ? client.UC_Status : "",
    UC_Message: client?.UC_Message ? client.UC_Message : "",
    UC_CreateTime: client?.UC_CreateTime ? client.UC_CreateTime : "",
    AddReferencePercentage: client?.AddReferencePercentage
      ? client.AddReferencePercentage
      : "",
    DontSendInvoiceToPrint: client?.DontSendInvoiceToPrint,
    MinAmountForPayment: client?.MinAmountForPayment
      ? client.MinAmountForPayment
      : 0,
    SubscriptionFee: client?.SubscriptionFee ? client.SubscriptionFee : 0,
    SubscriptionMonthlyFee: client?.SubscriptionMonthlyFee
      ? client.SubscriptionMonthlyFee
      : 0,
    SubscriptionMonthlyNextDate: client?.SubscriptionMonthlyNextDate
      ? client.SubscriptionMonthlyNextDate
      : "",
    SubscriptionNextDate: client?.SubscriptionNextDate
      ? client.SubscriptionNextDate
      : "",
    InvoiceAmountLimit: client?.InvoiceAmountLimit
      ? client.InvoiceAmountLimit
      : 0,
    Faktura_FooterText: client?.Faktura_FooterText
      ? client.Faktura_FooterText
      : "",
    Faktura_TransferText: client?.Faktura_TransferText
      ? client.Faktura_TransferText
      : "",
    Kredit_FooterText: client?.Kredit_FooterText
      ? client.Kredit_FooterText
      : "",
    Kredit_TransferText: client?.Kredit_TransferText
      ? client.Kredit_TransferText
      : "",
    Påminnelse_AlertText: client?.Påminnelse_AlertText
      ? client.Påminnelse_AlertText
      : "",
    Påminnelse_FooterText: client?.Påminnelse_FooterText
      ? client.Påminnelse_FooterText
      : "",
    Påminnelse_ReminderText: client?.Påminnelse_ReminderText
      ? client.Påminnelse_ReminderText
      : "",
    Räntefaktura_AlertText: client?.Räntefaktura_AlertText
      ? client.Räntefaktura_AlertText
      : "",
    Räntefaktura_FooterText: client?.Räntefaktura_FooterText
      ? client.Räntefaktura_FooterText
      : "",
    DeliveryOptionInvoice: client?.DeliveryOptionInvoice,
    DeliveryOptionReminder: client?.DeliveryOptionReminder,
    AllowPurchase: client?.AllowPurchase,
    Pm1Fee: client?.Pm1Fee ? client.Pm1Fee : 0,
    Pm1Ffd: client?.Pm1Ffd ? client.Pm1Ffd : 0,
    Pm1WaitCreate: client?.Pm1WaitCreate ? client.Pm1WaitCreate : 0,
    Pm2Fee: client?.Pm2Fee ? client.Pm2Fee : 0,
    Pm2Ffd: client?.Pm2Ffd ? client.Pm2Ffd : 0,
    Pm2WaitCreate: client?.Pm2WaitCreate ? client.Pm2WaitCreate : 0,
    Report_Payment_Subscription: client?.Report_Payment_Subscription
      ? client.Report_Payment_Subscription
      : "",
    Report_Collection_Subscription: client?.Report_Collection_Subscription
      ? client.Report_Collection_Subscription
      : "",
    Report_Settlement_Subscription: client?.Report_Settlement_Subscription
      ? client.Report_Settlement_Subscription
      : "",
    Report_Payout_Subscription: client?.Report_Payout_Subscription
      ? client.Report_Payout_Subscription
      : "",
    Report_Engagement_Subscription: client?.Report_Engagement_Subscription
      ? client.Report_Engagement_Subscription
      : "",
    Report_PaymentBgMax_Subscription: client?.Report_PaymentBgMax_Subscription
      ? client.Report_PaymentBgMax_Subscription
      : "",
    PurchaseServiceAboveAmount: client?.PurchaseServiceAboveAmount ?? null,
    FortnoxImportAll: client?.FortnoxImportAll ?? null,
    FortnoxReportBackPurchase: client?.FortnoxReportBackPurchase ?? null,
    FortnoxReportBackService: client?.FortnoxReportBackService ?? null,
    FortnoxReportBackPurchaseAccount:
      client?.FortnoxReportBackPurchaseAccount ?? null,
    FortnoxReportBackServiceAccount:
      client?.FortnoxReportBackServiceAccount ?? null,
    FVAT: client?.FVAT ?? null,
    CNrCollection: client?.CNrCollection ?? null,
    FortnoxSetAsSent: client?.FortnoxSetAsSent ?? null,
    FortnoxEmailBgmaxServiceDenied:
      client?.FortnoxEmailBgmaxServiceDenied ?? null,
    FortnoxEmailBgmaxPurchaseDenied:
      client?.FortnoxEmailBgmaxPurchaseDenied ?? null,
    FortnoxEmailBgmaxService: client?.FortnoxEmailBgmaxService ?? null,
    FortnoxEmailBgmaxPurchase: client?.FortnoxEmailBgmaxPurchase ?? null,
    AutoWriteOffAmount: client?.AutoWriteOffAmount ?? null,
  };
};
